const config: siteConfig = {
  REACT_APP_API_URL: "https://ttlefl.com/api",
  DIGI_SERVER_URL: "https://sds.softdigisolutions.com/",
};

export default config;
